import {
  paletteHelper,
  SkeletonText,
  spacingHelper,
  Stack,
  typographyHelper,
  radiusHelper,
  Ul,
  Li,
} from '@property.com.au/ui-kit';

import styled from 'styled-components';

export const StyledStack = styled(Stack)`
  margin-right: ${spacingHelper('large')};
`;

export const EstimationCard = styled.div`
  padding: ${spacingHelper('large')};
  border-radius: ${radiusHelper('medium')};
  background-color: ${paletteHelper('backgroundBlueSecondary')};

  && {
    /* Small hack to override the default margin-bottom of Stack in Dialog */
    margin-bottom: ${spacingHelper('extraLarge')};
  }
`;

export const BYBSkeletonText = styled(SkeletonText)`
  .skeletonTextContainer {
    background-color: ${paletteHelper('backgroundBlue')};
    background-image: unset;
  }
`;

export const BYBLogo = styled.img`
  width: 9.6875rem;
  height: 2.1875rem;
  margin-top: ${spacingHelper('extraSmall')};
`;

export const BYBPriceTitle = styled.p`
  ${typographyHelper('subtitle02')};
  margin-bottom: ${spacingHelper('twoExtraSmall')};
`;

export const BYBPriceTitleSkeleton = styled(BYBSkeletonText)`
  margin-bottom: ${spacingHelper('twoExtraSmall')};
`;

export const BYBPriceAndLogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const BYBPriceContainer = styled.div`
  display: flex;
  align-items: end;
  margin-right: ${spacingHelper('extraSmall')};
`;

export const BYBPriceLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > :not(:first-child) {
    margin-left: ${spacingHelper('extraLarge')};
  }
`;

export const BYBPrice = styled.p`
  ${typographyHelper('title02')}
`;

export const Asterisk = styled.span`
  ${typographyHelper('title03')};
  vertical-align: super;
`;

export const BYBFullPrice = styled.p`
  ${typographyHelper('subtitle01')};
  text-decoration: line-through;
  color: ${paletteHelper('textSecondary')};
  line-height: 1.875rem;
  margin-left: ${spacingHelper('twoExtraSmall')};
`;

export const BYBPriceDisclaimer = styled.p`
  ${typographyHelper('body02')}
  color: ${paletteHelper('textBlue')};
  margin-top: ${spacingHelper('medium')};

  span {
    ${typographyHelper('body02')}
    color: ${paletteHelper('textBlue')};
  }

  a {
    ${typographyHelper('body02')}
  }
`;

export const BYBPriceDisclaimerSkeleton = styled(BYBSkeletonText)`
  margin-top: ${spacingHelper('medium')};
`;

export const BYBEtaSkeletonText = styled(SkeletonText)`
  margin-left: ${spacingHelper('medium')};
  width: 200px;
`;

export const InfoSection = styled.div`
  flex-grow: 1;
  & > p {
    ${typographyHelper('subtitle02')};
    margin-bottom: ${spacingHelper('small')};
  }
`;

export const FeatureList = styled(Ul)`
  padding-inline-start: ${spacingHelper('large')};
`;

export const FeatureListItem = styled(Li)`
  margin-bottom: ${spacingHelper('extraSmall')};
`;

export const InfoList = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: calc(${spacingHelper('medium')} + ${spacingHelper('twoExtraSmall')});
  margin-top: ${spacingHelper('extraLarge')};
`;

export const InfoListItem = styled.li`
  display: flex;
  align-items: center;
  column-gap: ${spacingHelper('small')};

  p {
    color: ${paletteHelper('textSecondary')};
    ${typographyHelper('body02')};
  }

  &::before {
    flex-shrink: 0;
    content: ' ';
    display: block;
    background-color: ${paletteHelper('textPrimary')};
    width: 1rem;
    height: 1rem;
    border: 4.5px solid ${paletteHelper('backgroundPrimaryBase')};
    border-radius: 50px;
    box-shadow:
      0 1px 1px 0 #616973,
      0 0 2px 0 rgb(105 114 127 / 67%);
  }
`;

export const DynamicContentWrapper = styled.div`
  a,
  span {
    ${typographyHelper('body02')};
  }

  span {
    color: ${paletteHelper('textSecondary')};
  }
`;

export const ETAContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ETA = styled.p`
  margin-left: ${spacingHelper('small')};
  ${typographyHelper('body02Bold')};
`;

export const DisclaimerButton = styled.button`
  ${typographyHelper('body02')};
  color: ${paletteHelper('textSecondary')};
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }
`;
